(() => {
  if (window.jarBundleCartLoaded) return;
  window.jarBundleCartLoaded = true;

  const CONTAINER_SELECTOR = 'cart-drawer-items, cart-items';
  const ROW_SELECTOR = '[id^="CartDrawer-Item-"], [id^="CartItem-"]';
  const WATCH_SELECTOR = 'cart-drawer, #main-cart-items';
  const ICONS = {
    minus:
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 2" width="10" height="2" aria-hidden="true" focusable="false"><path fill="currentColor" fill-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 1 1 0 1H1A.5.5 0 0 1 .5 1" clip-rule="evenodd"/></svg>',
    plus:
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 10" width="10" height="10" aria-hidden="true" focusable="false"><path fill="currentColor" fill-rule="evenodd" d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5z" clip-rule="evenodd"/></svg>',
    remove:
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" width="18" height="18" aria-hidden="true" focusable="false"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M2.5 4h11M6.5 7v5M9.5 7v5M3.5 4l.7 9.1a1 1 0 0 0 1 .9h5.6a1 1 0 0 0 1-.9l.7-9.1M6 4V2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V4"/></svg>',
  };

  const stepTimers = new Map();
  let runId = 0;
  let runTimer;

  /* ---------- helpers ---------- */

  function formatMoney(cents) {
    const format = (window.jarBundleMoneyFormat || '{{amount}}').replace(/<[^>]*>/g, '');
    const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return format;
    const value = Number(cents) / 100;
    const build = (decimals, thousands = ',', decimal = '.') => {
      const [whole, fraction] = value.toFixed(decimals).split('.');
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (fraction ? decimal + fraction : '');
    };
    const amount = {
      amount: () => build(2),
      amount_no_decimals: () => build(0),
      amount_with_comma_separator: () => build(2, '.', ','),
      amount_no_decimals_with_comma_separator: () => build(0, '.', ','),
      amount_with_apostrophe_separator: () => build(2, "'", '.'),
      amount_no_decimals_with_space_separator: () => build(0, ' '),
      amount_with_space_separator: () => build(2, ' ', ','),
      amount_with_period_and_space_separator: () => build(2, ' ', '.'),
    }[match[1]] || (() => build(2));
    return format.replace(match[0], amount());
  }

  function cartUrl(path) {
    const root = (window.routes && window.routes.cart_url) || '/cart';
    return `${root}${path}`;
  }

  function findRow(container, index) {
    return container.querySelector(`#CartDrawer-Item-${index + 1}, #CartItem-${index + 1}`);
  }

  /* ---------- group cart lines by _bundle_id ---------- */

  function getBundles(cart) {
    const bundles = new Map();

    cart.items.forEach((item, index) => {
      const properties = item.properties || {};
      const bundleId = properties._bundle_id;
      if (!bundleId) return;

      if (!bundles.has(bundleId)) {
        bundles.set(bundleId, {
          id: bundleId,
          name: properties._bundle_name || '',
          image: properties._bundle_image || '',
          message: '',
          lines: [],
        });
      }

      const bundle = bundles.get(bundleId);
      if (properties['Gift Message']) bundle.message = properties['Gift Message'];
      bundle.lines.push({
        index,
        key: item.key,
        quantity: item.quantity,
        count: Math.max(1, parseInt(properties._bundle_count, 10) || 1),
        role: properties._bundle_role || 'jar',
        finalPrice: item.final_line_price,
        originalPrice: item.original_line_price,
        image: item.image,
      });
    });

    bundles.forEach((bundle) => {
      bundle.lines.sort((a, b) => Number(a.role === 'gift_card') - Number(b.role === 'gift_card'));
      const first = bundle.lines[0];
      bundle.quantity = Math.max(1, Math.round(first.quantity / first.count));
      bundle.jars = bundle.lines.filter((line) => line.role !== 'gift_card').reduce((sum, line) => sum + line.count, 0);
      bundle.hasGiftCard = bundle.lines.some((line) => line.role === 'gift_card');
      bundle.total = bundle.lines.reduce((sum, line) => sum + line.finalPrice, 0);
      bundle.original = bundle.lines.reduce((sum, line) => sum + line.originalPrice, 0);
      if (!bundle.image) bundle.image = first.image || '';
    });

    return Array.from(bundles.values());
  }

  /* ---------- DOM ---------- */

  function buildHeader(bundle, columns) {
    const row = document.createElement('tr');
    row.className = 'jb-bundle-header';
    row.dataset.bundleId = bundle.id;
    row.dataset.quantity = bundle.quantity;
    row.dataset.lines = JSON.stringify(bundle.lines.map((line) => ({ key: line.key, count: line.count })));

    row.innerHTML = `
      <td colspan="${columns}">
        <div class="jb-bundle-header__inner">
          <div class="jb-bundle-header__media"></div>
          <div class="jb-bundle-header__info">
            <p class="jb-bundle-header__name"></p>
            <p class="jb-bundle-header__meta"></p>
            <p class="jb-bundle-header__message" hidden></p>
            <div class="jb-bundle-header__actions">
              <div class="quantity jb-bundle-qty">
                <button type="button" class="quantity__button" data-jb-step="-1">${ICONS.minus}</button>
                <span class="quantity__input jb-bundle-qty__value" data-jb-qty aria-live="polite"></span>
                <button type="button" class="quantity__button" data-jb-step="1">${ICONS.plus}</button>
              </div>
              <button type="button" class="button button--tertiary jb-bundle-remove" data-jb-remove>${ICONS.remove}</button>
            </div>
          </div>
          <div class="jb-bundle-header__price"></div>
        </div>
      </td>`;

    const name = bundle.name || 'Gift box';

    if (bundle.image) {
      const image = document.createElement('img');
      image.className = 'jb-bundle-header__image';
      image.src = bundle.image;
      image.alt = name;
      image.width = 140;
      image.height = 140;
      image.loading = 'lazy';
      row.querySelector('.jb-bundle-header__media').append(image);
    }

    row.querySelector('.jb-bundle-header__name').textContent = name;
    row.querySelector('.jb-bundle-header__meta').textContent =
      `${bundle.jars} ${bundle.jars === 1 ? 'jar' : 'jars'}${bundle.hasGiftCard ? ' + gift card' : ''}`;

    if (bundle.message) {
      const message = row.querySelector('.jb-bundle-header__message');
      message.textContent = `Gift message: ${bundle.message}`;
      message.hidden = false;
    }

    const quantityValue = row.querySelector('[data-jb-qty]');
    quantityValue.textContent = bundle.quantity;

    const minus = row.querySelector('[data-jb-step="-1"]');
    minus.disabled = bundle.quantity <= 1;
    minus.setAttribute('aria-label', `Decrease quantity for ${name}`);
    row.querySelector('[data-jb-step="1"]').setAttribute('aria-label', `Increase quantity for ${name}`);
    row.querySelector('[data-jb-remove]').setAttribute('aria-label', `Remove ${name}`);

    const price = row.querySelector('.jb-bundle-header__price');
    if (bundle.original > bundle.total) {
      const original = document.createElement('s');
      original.textContent = formatMoney(bundle.original);
      price.append(original);
    }
    const total = document.createElement('span');
    total.textContent = formatMoney(bundle.total);
    price.append(total);

    return row;
  }

  function decorateChild(row, line, bundle, isLast) {
    row.classList.add('jb-cart-child');
    row.classList.toggle('jb-cart-child--last', isLast);
    row.dataset.bundleId = bundle.id;
    row.setAttribute('aria-label', `Part of ${bundle.name || 'gift box'}`);

    if (!row.querySelector('.jb-cart-locked')) {
      const locked = document.createElement('span');
      locked.className = 'jb-cart-locked';
      locked.textContent = `× ${line.quantity}`;
      const anchor = row.querySelector('quantity-popover') || row.querySelector('quantity-input');
      if (anchor) anchor.before(locked);
      else (row.querySelector('.cart-item__details') || row.lastElementChild).append(locked);
    }

    // The gift message is shown once, in the bundle header.
    row.querySelectorAll('.product-option').forEach((option) => {
      const label = option.querySelector('dt');
      if (label && label.textContent.trim().startsWith('Gift Message')) option.style.display = 'none';
    });
  }

  function decorateContainer(container, bundles) {
    container.querySelectorAll('.jb-bundle-header').forEach((header) => header.remove());

    bundles.forEach((bundle) => {
      const pairs = bundle.lines
        .map((line) => ({ line, row: findRow(container, line.index) }))
        .filter((pair) => pair.row);
      if (!pairs.length) return;

      const header = buildHeader(bundle, pairs[0].row.children.length || 1);
      pairs[0].row.before(header);

      let anchor = header;
      pairs.forEach(({ line, row }, position) => {
        anchor.after(row);
        anchor = row;
        decorateChild(row, line, bundle, position === pairs.length - 1);
      });
    });
  }

  /* ---------- run after every cart render ---------- */

  const observer = new MutationObserver(scheduleRun);

  function observe() {
    document.querySelectorAll(WATCH_SELECTOR).forEach((element) => {
      observer.observe(element, { childList: true, subtree: true });
    });
  }

  function scheduleRun() {
    clearTimeout(runTimer);
    runTimer = setTimeout(run, 60);
  }

  async function run() {
    const containers = Array.from(document.querySelectorAll(CONTAINER_SELECTOR));
    if (!containers.length || !document.querySelector(ROW_SELECTOR)) return;

    const currentRun = ++runId;
    let cart;
    try {
      const response = await fetch(cartUrl('.js'), { headers: { Accept: 'application/json' } });
      cart = await response.json();
    } catch (error) {
      return;
    }
    if (currentRun !== runId) return;

    const bundles = getBundles(cart);
    observer.disconnect();
    containers.forEach((container) => decorateContainer(container, bundles));
    observe();
  }

  /* ---------- bundle quantity / remove ---------- */

  async function updateBundle(header, quantity) {
    const cartItems = header.closest(CONTAINER_SELECTOR);
    const lines = JSON.parse(header.dataset.lines || '[]');
    const sections = cartItems && cartItems.getSectionsToRender ? cartItems.getSectionsToRender() : [];
    const updates = {};
    lines.forEach((line) => {
      updates[line.key] = line.count * quantity;
    });

    header.classList.add('is-loading');

    try {
      const response = await fetch(cartUrl('/update.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          updates,
          sections: sections.map((section) => section.section),
          sections_url: window.location.pathname,
        }),
      });
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || state.message);

      if (!sections.length || !state.sections) {
        window.location.reload();
        return;
      }

      const isEmpty = state.item_count === 0;
      cartItems.classList.toggle('is-empty', isEmpty);
      document.querySelector('cart-drawer')?.classList.toggle('is-empty', isEmpty);
      document.getElementById('main-cart-footer')?.classList.toggle('is-empty', isEmpty);

      sections.forEach((section) => {
        const container = document.getElementById(section.id);
        if (!container) return;
        const target = container.querySelector(section.selector) || container;
        target.innerHTML = cartItems.getSectionInnerHTML(state.sections[section.section], section.selector);
      });

      // Same event Dawn fires after cart changes, so Shopflo and other listeners get the latest cart.
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: state });
      }
    } catch (error) {
      header.classList.remove('is-loading');
      const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      if (errors) errors.textContent = error.message || (window.cartStrings && window.cartStrings.error) || 'Something went wrong.';
    }
  }

  document.addEventListener('click', (event) => {
    const header = event.target.closest('.jb-bundle-header');
    if (!header) return;

    const removeButton = event.target.closest('[data-jb-remove]');
    const stepButton = event.target.closest('[data-jb-step]');
    if (!removeButton && !stepButton) return;
    event.preventDefault();

    const bundleId = header.dataset.bundleId;
    clearTimeout(stepTimers.get(bundleId));

    if (removeButton) {
      updateBundle(header, 0);
      return;
    }

    const next = Math.max(1, (parseInt(header.dataset.quantity, 10) || 1) + parseInt(stepButton.dataset.jbStep, 10));
    header.dataset.quantity = next;
    header.querySelector('[data-jb-qty]').textContent = next;
    header.querySelector('[data-jb-step="-1"]').disabled = next <= 1;

    const delay = typeof ON_CHANGE_DEBOUNCE_TIMER === 'number' ? ON_CHANGE_DEBOUNCE_TIMER : 300;
    stepTimers.set(bundleId, setTimeout(() => updateBundle(header, next), delay));
  });

  /* ---------- start ---------- */

  function init() {
    observe();
    run();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();